module.exports = __webpack_public_path__ + "39b5e9a366e1f913dc6f73eab5d270de.jpg";